import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./RecentlyPlayed.module.scss";
import {useRecentlyPlayedLogic} from "./RecentlyPlayed.logic";
import {RecentLessonCards} from "./recent-lesson-cards/RecentLessonCards";

export const RecentlyPlayed: VoidFunctionComponent = () => {
  const {lessons} = useRecentlyPlayedLogic();

  return <section className={s.recentlyPlayed}>
    <h2 className={s.title}>Most recently played</h2>
    <RecentLessonCards lessons={lessons} />
  </section>;
}
